import React from 'react';
import { Spinner } from 'reactstrap';

const ModalLoader = () => {
    return (
        <React.Fragment>
            <div className="position-absolute top-50 start-50 full-zindex">
                <Spinner color="primary" className="spinner-style" />
            </div>
        </React.Fragment>
    );
};

export default ModalLoader;
